import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import SideBarLink from 'components/atoms/sidebar/SideBarLink';
import SideBarCategory from 'components/atoms/sidebar/SideBarCategory';
import SideBarShell from 'components/atoms/sidebar/SideBarShell';
import SideBarUl from 'components/atoms/sidebar/SideBarUl';
import { fetchCurrentUser, destroyCurrentUserSession } from 'services/users/duck';
import { closeMobileNav } from 'services/layout/duck';
import { determineActiveLink } from 'helpers/sideBar';
import { findIndexofAttribute } from 'helpers/utilities';
import { withBreakpoints } from 'react-breakpoints';
import UserFeedback from 'components/organisms/UserFeedback';


class SideBarContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            constructedNav: this.props.embeddedLinks.length > 0 ?
                this.insertEmbeddedLinks(this.props.navItems, this.props.embeddedLinks, this.props.currentUser) :
                this.props.navItems,
        };

        this.clickAction = this.clickAction.bind(this);
        this.insertEmbeddedLinks = this.insertEmbeddedLinks.bind(this);
    }

    componentDidMount() {
        if (this.props.loggedIn && !this.props.currentUser) {
            this.props.fetchCurrentUser({ disableNavigation: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.entityId !== nextProps.entityId) {
            this.setState({
                constructedNav: nextProps.embeddedLinks.length > 0 ?
                    this.insertEmbeddedLinks(nextProps.navItems, nextProps.embeddedLinks, nextProps.currentUser) :
                    nextProps.navItems
            });
        // }
        }
    }

    clickAction(clickPath) {
        if (this.props.breakpoints[this.props.currentBreakpoint] < this.props.breakpoints.lg) {
            this.props.closeMobileNav();
        }
        window.scrollTo(0, 0);
        if (this.props.push) {
            this.props.push(clickPath);
        }
    }

    insertEmbeddedLinks(navItems, embeddedLinks, currentUser) {
        const isOkta = get(currentUser, 'isOkta', false);
        // create a copy of navItems as not to mutate the original
        const navItemsWithLinks = [...navItems];
        const embeddedLinkLinks = embeddedLinks
            .filter(embeddedLink => isOkta || embeddedLink.enabled)
            .map(embeddedLink =>
                ({
                    name: embeddedLink.name,
                    channel: 'custom',
                    path: `/dashboard/{entityId}/embed/${embeddedLink.slug}`,
                    type: 'link'
                })
            );

        // add custom channels to navItems
        if (embeddedLinkLinks.length > 0) {
            // this is the category for the custom channel block
            embeddedLinkLinks.unshift({
                name: 'Custom',
                isBeta: true,
                type: 'category',
            });
            // we use the lab header as the position to insert the custom channel block
            const labHeaderIndex = findIndexofAttribute(navItems, 'name', 'Labs');

            if (labHeaderIndex !== -1) {
                embeddedLinkLinks.map((embeddedLinkLink, index) =>
                    navItemsWithLinks.splice(labHeaderIndex + index, 0, embeddedLinkLink));
            }
        }

        return navItemsWithLinks;
    }

    render() {
        const userScope = get(this.props, 'currentUser.scope', []);
        const { constructedNav } = this.state;

        const filteredNavItems = constructedNav.filter((item) => {
            // This is saying that if the item has a scope declared it will
            // default to being hidden if the user is either not loaded or
            // doesn't have the scope needed.
            if (item.scope) {
                let scopeList = item.scope;

                if (!Array.isArray(item.scope)) {
                    scopeList = [scopeList];
                }

                for (const scopeKey of scopeList) {
                    if (!userScope.includes(scopeKey)) {
                        return false;
                    }
                }
            }

            // Show the nav for Insights if there is a custom channel
            if (item.channel === 'custom') {
                return true;
            }

            // This will filter out Channels that are not enabled via the Brand
            // Default Channels returned from the API. We always want to render
            // the Summary tab, so that is bypassed.
            if (item.channel &&
                (this.props.enabledChannels.indexOf(item.channel) === -1
                    || this.props.enforceSummaryOnlyDashboardView
                )
            ) {
                return false;
            }

            return true;
        }).map((item) => {
            const path = item.path ? item.path.replace('{entityId}', this.props.entityId) : '';

            return { ...item, path };
        });

        let accountName = 'My Account';

        if (this.props.currentUser) {
            accountName = this.props.currentUser.fullName;
        }

        return (
            <SideBarShell admin={this.props.admin} brandBranding={this.props.brandBranding}>
                <SideBarUl>

                    {/* TODO: Re-enable after we work out how we will handle the profile section */}
                    {filteredNavItems.map((item) => {
                        if (item.type === 'category') {
                            return (
                                <li key={`nav-${item.name}`}>
                                    <SideBarCategory
                                        categoryName={item.name}
                                        isInternal={item.isInternal}
                                        isBeta={item.isBeta}
                                    />
                                </li>);
                        }

                        return (
                            <li key={`nav-${item.name}`}>
                                <SideBarLink
                                    admin={this.props.admin}
                                    isActive={determineActiveLink({ item, location: this.props.location })}
                                    clickAction={() => this.clickAction(item.path)}
                                    linkName={item.name}
                                    icon={item.icon}
                                />
                            </li>);
                    }

                    )}
                </SideBarUl>
                {this.props.loggedIn &&
                    <SideBarUl admin={this.props.admin} anchorToBottom>
                        <UserFeedback />
                        <li key='logout'>
                            <SideBarLink
                                isLogOut
                                admin={this.props.admin}
                                clickAction={this.props.destroyCurrentUserSession}
                                linkName={`${accountName}`}
                                icon='icon-logout' />
                        </li>
                    </SideBarUl>
                }
            </SideBarShell>
        );
    }
}

SideBarContainer.propTypes = {
    navItems: PropTypes.array.isRequired,
    breakpoints: PropTypes.object,
    currentBreakpoint: PropTypes.string
};

const mapStateToProps = state => ({
    entityId: state.entities.meta.id,
    currentUser: state.users.currentUser,
    loggedIn: state.auth.loggedIn,
    location: state.router.location,
    enabledChannels: state.entities.meta.enabledChannels,
    embeddedLinks: get(state, 'entities.meta.embeddedLinks', []),
    enforceSummaryOnlyDashboardView: get(state, 'entities.meta.meta.enforceSummaryOnlyDashboardView', false),
    brandBranding: state.entities.meta.brandBranding
});

export default withBreakpoints(connect(mapStateToProps, {
    fetchCurrentUser, destroyCurrentUserSession, closeMobileNav, push
})(SideBarContainer));



// WEBPACK FOOTER //
// ./src/containers/SideBarContainer.js